
export default {
  name: 'PageTerms',

  head() {
    return {
      title: 'Terms and conditions',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Read the terms and conditions for the use of Paw Paddock services'
        }
      ]
    }
  },

  computed: {
    compHero() {
      return {
        title: 'Terms and conditions',
        image: require('~/assets/images/backgrounds/voucher-hero.jpg'),
        alt: '3 dogs in a paddock'
      }
    }
  }
}
